<script setup lang="ts">
import {computed, ref} from "vue";
import {getOpengraphData} from "@/Services/stimuli";
import {Icon} from "@iconify/vue";
import {Question} from "@/Types/question.d";
import Stimulus from "@/Models/Stimulus";

const props = defineProps<{question: Question; stimulus?: Stimulus; placement?: string}>();
const stimulus = computed(() => props.question.stimuli?.[0] ?? props.stimulus ?? null);
const ogMeta = ref(stimulus.value?.ogMeta);
if (!ogMeta.value && stimulus.value?.data && ["url", "video"].includes(stimulus.value.type.slug)) {
    getOpengraphData(stimulus.value.id)
        .then((data) => {
            if (!ogMeta.value) {
                ogMeta.value = data;
            } else {
                Object.assign(ogMeta.value, data);
            }
        })
        .catch((error) => {
            console.error(error);
            ogMeta.value = {
                error: error,
            };
        });
}
</script>
<template>
    <div class="relative">
        <div v-if="question.params?.cover_image_type === 'custom' && question.cover_image">
            <img
                :src="question.cover_image.url"
                alt="Cover Image"
                class="aspect-video w-full object-contain"
                :class="[
                    placement === 'top' ? 'rounded-t-md' : 'rounded-md border border-stone-400 dark:border-stone-700',
                ]"
            />
            <div class="absolute right-3 top-3 text-white" v-if="stimulus">
                <Icon :icon="stimulus.type.icon" width="28" class="drop-shadow-[0_4px_4px_rgba(0,0,0,0.9)]" />
            </div>
        </div>
        <div
            v-else-if="
                question.params?.cover_image_type === 'stimulus' &&
                (ogMeta?.image || (!['audio', 'document'].includes(stimulus?.type.slug) && stimulus?.files?.[0]?.url))
            "
            class="flex flex-col items-center justify-center"
            :class="[placement === 'top' ? 'rounded-t-md' : 'rounded-md']"
        >
            <img
                :src="ogMeta?.image ?? stimulus?.files?.[0]?.url"
                alt="Stimulus"
                class="aspect-video w-full object-contain"
                :class="[
                    placement === 'top' ? 'rounded-t-md' : 'rounded-md border border-stone-400 dark:border-stone-700',
                ]"
            />
            <div class="absolute right-3 top-3 text-white" v-if="stimulus">
                <Icon
                    :icon="stimulus.type.icon"
                    width="28"
                    class="shadow-black drop-shadow-[0_4px_4px_rgba(0,0,0,0.9)]"
                />
            </div>
        </div>
        <!--        <div v-else class="flex aspect-video w-full items-center justify-center bg-stone-100 dark:bg-stone-800/50">-->
        <!--            <p class="text-xs text-stone-400">No image</p>-->
        <!--        </div>-->
    </div>
</template>
<style scoped></style>
